import { useEffect, useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { styled } from '@mui/material/styles';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUrlEntityId } from '@/components/App/hooks';
import { useAppSelector } from '@/reducers/rootReducer';
import { entityInfoSelectors } from '@/reducers/entityInfoSlice';
import { getUrlTypeForEntity } from '@/common/utils';

export const TabsContainer = styled(Tabs)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.text.brandSecondary,
  },

  '& .MuiTabs-list': {
    gap: theme.lelySpacing.SM,
  },
}));

const TabItem = styled(Tab)(({ theme }) => ({
  fontFamily: theme.lelyFontFamily.UBUNTU,
  fontSize: theme.lelyFontSize.BASE,
  color: theme.palette.text.default,
  paddingInline: 0,
  textTransform: 'none',
  height: 42,
  opacity: 1,
  minHeight: 'auto',
  minWidth: 'auto',

  '&.Mui-selected': {
    color: theme.palette.text.default,
    fontWeight: 500,
  },
}));

type TabSetting = {
  label: string;
  page: string;
};

const SettingsTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const entityId = useUrlEntityId();

  const entityInfo = useAppSelector(entityInfoSelectors.selectEntityInfo);
  const entityUrlType = getUrlTypeForEntity(entityInfo?.type);

  const [value, setValue] = useState(-1);

  const hasBackupsPage = entityUrlType === 'astronaut';

  const tabs: TabSetting[] = [
    { label: 'Settings', page: `${entityUrlType}/settings` },

    ...(hasBackupsPage
      ? [{ label: 'Backups', page: `${entityUrlType}/settings/backups` }]
      : []),
  ];

  useEffect(() => {
    const pathname = location.pathname;

    if (tabs.length > 1) {
      const activeTabValue = tabs.findIndex(({ page }) =>
        pathname.endsWith(`/entities/${entityId}/${page}`),
      );

      setValue(activeTabValue);
    }
  }, [[location, tabs]]);

  const handleChange = (newValue: number) => {
    setValue(newValue);
  };

  const handleNavigate = (page: string) => {
    if (entityId) {
      navigate(`/entities/${entityId}/${page}`);
    }
  };

  return (
    <TabsContainer
      value={value}
      onChange={(_, newValue) => {
        handleChange(newValue);
      }}
    >
      {tabs.map((t) => (
        <TabItem
          disableRipple
          key={t.label}
          label={t.label}
          onClick={() => {
            handleNavigate(t.page);
          }}
        />
      ))}
    </TabsContainer>
  );
};
export default SettingsTabs;
